import axios from "axios";
import { toast } from "react-toastify";
import { postToNative } from "./nativeBridge";

const API_URL = process.env.NODE_ENV === "production" ? "https://www.ciaowin35.com/api/pos" : "http://debug.ciaowin35.com/api/pos" ; // https://apidebug.ciaowin35.com/api/pos

// axios 实例封装
const api_client = axios.create({
    baseURL: API_URL,
    timeout: 15000,
});

// JWT Token 中间件
api_client.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("token"); // 从 localStorage 获取 JWT token
        if (token) {
            config.headers.Authorization = `Bearer ${token}`; // 添加 JWT token 到 headers
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// 自動重新登入（後端無 refresh API，用 localStorage 中保存的帳密靜默重登）
let reloginPromise = null;
let hasShownExpiredLoginToast = false;

// 回傳 token；明確被拒（無憑證、後端 error !== 0、HTTP 401/403）回 null；網路錯誤／逾時則拋出
const doRelogin = async () => {
    const raw = localStorage.getItem("_ac");
    if (!raw) return null;
    let creds;
    try {
        creds = JSON.parse(decodeURIComponent(escape(atob(raw))));
    } catch (e) {
        return null;
    }
    // 直接使用 axios 而非 api_client，避免 interceptor 遞迴
    let res;
    try {
        res = await axios.post(`${API_URL}/login`, {
            account: creds.account,
            password: creds.password,
        }, { timeout: 15000 });
    } catch (e) {
        const status = e && e.response && e.response.status;
        if (status === 401 || status === 403) return null; // 明確被拒
        throw e; // 網路錯誤／逾時／5xx：不是憑證問題，不可登出
    }
    if (res.data && res.data.error === 0 && res.data.token) {
        localStorage.setItem("token", res.data.token);
        postToNative('authRefreshed', { token: res.data.token });
        return res.data.token;
    }
    return null;
};

api_client.interceptors.response.use(
    (response) => response,
    async (error) => {
        const original = error.config;
        if (error.response && error.response.status === 401 && original && !original._retry) {
            original._retry = true;
            try {
                if (!reloginPromise) {
                    reloginPromise = doRelogin().finally(() => { reloginPromise = null; });
                }
                const newToken = await reloginPromise;
                if (newToken) {
                    original.headers = original.headers || {};
                    original.headers.Authorization = `Bearer ${newToken}`;
                    return api_client(original);
                }
            } catch (e) {
                // 暫時性失敗（網路／逾時）：只拒絕原請求，不登出，保留憑證待網路恢復
                return Promise.reject(error);
            }
            // Token 過期且無法自動重登，清除狀態並導回登入頁
            localStorage.removeItem("jwtToken");
            localStorage.removeItem("token");
            localStorage.removeItem("_ac");
            postToNative("logout");
            error.__handled = true;
            if (!hasShownExpiredLoginToast) {
                hasShownExpiredLoginToast = true;
                toast.error("登入過期，請重新登入");
            }
            window.location.href = ("/");
        }
        return Promise.reject(error);
    }
);

export default api_client;
